import { render, staticRenderFns } from "./bmfw.vue?vue&type=template&id=2e5dfaba&scoped=true&"
import script from "./bmfw.vue?vue&type=script&lang=js&"
export * from "./bmfw.vue?vue&type=script&lang=js&"
import style0 from "./bmfw.vue?vue&type=style&index=0&id=2e5dfaba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5dfaba",
  null
  
)

export default component.exports